import * as React from 'react';
import { connect } from 'react-redux';
import WarrantyClaimDetails from './WarrantyClaimDetails/WarrantyClaimDetails';
import WarrantyClaimEnd from './WarrantyClaimEnd/WarrantyClaimEnd';
import '../FNOL.css'

class WarrantyClaimsJourney extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    public render() {
        return (
            <>
                {this.props.claimSubmit.selectedClaimStep.step === 2 &&
                    <>
                        <WarrantyClaimDetails />
                    </>
                }
                {this.props.claimSubmit.selectedClaimStep.step === 3 &&
                    <>
                        <WarrantyClaimEnd />
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(WarrantyClaimsJourney)
